"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_keyboard_aware_scroll_view_1 = require("react-native-keyboard-aware-scroll-view");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const icons_1 = require("../../../assets/icons");
const components_1 = require("../../../components");
const LoadingLogin_1 = __importDefault(require("../../../components/loading/LoadingLogin"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const messages_1 = require("../../../constants/messages");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const User_1 = __importDefault(require("../../../networking/apis/User"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const InputItem = (props) => {
    const { label, onChangeValue, style = {}, errorMessage, ...rest } = props;
    const [isSecureText, setSecureText] = (0, react_1.useState)(true);
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.inputItem, style] },
        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.inputLabel }, label),
        react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.inputItemBody,
                !!errorMessage && { borderColor: '#F80F63', backgroundColor: '#FDF3F3' },
                isFocused && { borderColor: '#00AEEF', backgroundColor: '#FEFEFE' },
            ] },
            react_1.default.createElement(react_native_1.TextInput, { style: styles_1.default.textInput, secureTextEntry: isSecureText, onChangeText: onChangeValue, ...rest, onFocus: handleFocus, onBlur: handleBlur }),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => setSecureText(!isSecureText) }, isSecureText ? (react_1.default.createElement(icons_1.IC_EYES_OPEN, { width: (0, scale_1.scale)(22), height: (0, scale_1.scale)(22) })) : (react_1.default.createElement(icons_1.IC_EYES_CLOSE, { width: (0, scale_1.scale)(22), height: (0, scale_1.scale)(22) })))),
        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.textError }, errorMessage)));
};
const initialFormValue = {
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
};
const defaultErrorMessage = {
    current_password: '',
    new_password: '',
    new_password_confirmation: '',
};
const ChangePasswordScreen = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [errorMessages, setErrorMessages] = (0, react_1.useState)(defaultErrorMessage);
    const refFormValue = (0, react_1.useRef)(initialFormValue);
    //validate input
    const validateForm = () => {
        let _error = { ...defaultErrorMessage };
        const { current_password, new_password, new_password_confirmation } = refFormValue.current;
        if (!current_password) {
            _error.current_password = messages_1.MESSAGES.CURRENT_PASSWORD_IS_REQUIRED;
        }
        else if (!constants_1.REGEX_PASSWORD.test(current_password)) {
            _error.current_password = messages_1.MESSAGES.PASSWORD_INVALID;
        }
        if (!new_password) {
            _error.new_password = messages_1.MESSAGES.NEW_PASSWORD_IS_REQUIRED;
        }
        else if (current_password === new_password) {
            _error.new_password = messages_1.MESSAGES.NEW_PASSWORD_MUST_BE_DIFFERENT_CURRENT_PASSWORD;
        }
        else if (!constants_1.REGEX_PASSWORD.test(new_password)) {
            _error.new_password = messages_1.MESSAGES.PASSWORD_INVALID;
        }
        if (!new_password_confirmation) {
            _error.new_password_confirmation = messages_1.MESSAGES.CONFIRM_PASSWOR_IS_REQUIRED;
        }
        else if (new_password_confirmation !== new_password) {
            _error.new_password_confirmation = messages_1.MESSAGES.PASSWORD_NOT_MATCH;
        }
        setErrorMessages(_error);
        return !Object.keys(_error).some((key) => !!_error[key]);
    };
    const handleSubmit = async () => {
        const isValid = validateForm();
        if (!isValid)
            return;
        setErrorMessages(defaultErrorMessage);
        setLoading(true);
        try {
            const formData = refFormValue.current;
            await User_1.default.changePassword(formData);
            (0, rootNavigation_1.replace)(Routes_1.default.CHANGE_PASSWORD_SUCCESS);
            dispatch(slice_1.default.actions.showToast('パスワードを変更しました'));
        }
        catch (error) {
            if ((0, helpler_1.isAxiosUnprocessableEntityError)(error)) {
                const errorObj = (0, helpler_1.handleApiError)(error.response.data);
                if (errorObj) {
                    setErrorMessages(errorObj);
                }
                return;
            }
            const errorMessage = error.response?.data?.error?.message;
            if (errorMessage) {
                setErrorMessages((prev) => ({ ...prev, current_password: errorMessage }));
            }
            // dispatch(appSlice.actions.setToastType(false))
            // dispatch(appSlice.actions.showToast(errorMessage || MESSAGES.ERROR_MESSAGE_DEFAULT))
        }
        finally {
            setLoading(false);
        }
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
            }, title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4", styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.headerBackLabel }, "\u30AD\u30E3\u30F3\u30BB\u30EB") }),
        react_1.default.createElement(react_native_keyboard_aware_scroll_view_1.KeyboardAwareScrollView, { contentContainerStyle: styles_1.default.body },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.rectangle }),
                react_1.default.createElement(CustomText_1.default, { style: styles_1.default.title }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4")),
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.description }, "\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9\u3068\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
            react_1.default.createElement(InputItem, { label: "\u73FE\u5728\u306E\u30D1\u30B9\u30EF\u30FC\u30C9", style: { marginTop: (0, scale_1.scale)(24) }, onChangeValue: (val) => (refFormValue.current.current_password = val), errorMessage: errorMessages.current_password, maxLength: 50 }),
            react_1.default.createElement(InputItem, { label: "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9", onChangeValue: (val) => (refFormValue.current.new_password = val), errorMessage: errorMessages.new_password, maxLength: 50 }),
            react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(11),
                    lineHeight: (0, scale_1.moderateScale)(16),
                    color: '#545454',
                    fontWeight: '300',
                    width: (0, scale_1.scale)(343),
                    textAlign: 'left',
                    marginTop: (0, scale_1.scale)(8),
                } }, "\u203B10\uFF5E50\u6587\u5B57\u3067\u3001\u5927\u6587\u5B57\u82F1\u5B57\u3001\u5C0F\u6587\u5B57\u82F1\u5B57\u3001\u6570\u5B57\u3001\u8A18\u53F7\u3092\u305D\u308C\u305E\u308C\u542B\u3080\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002"),
            react_1.default.createElement(InputItem, { label: "\u65B0\u3057\u3044\u30D1\u30B9\u30EF\u30FC\u30C9(\u78BA\u8A8D\u7528)", onChangeValue: (val) => (refFormValue.current.new_password_confirmation = val), errorMessage: errorMessages.new_password_confirmation, maxLength: 50 }),
            react_1.default.createElement(components_1.LinearButton, { title: "\u4FDD\u5B58", fontWeight: "600", style: styles_1.default.submitButton, textStyle: styles_1.default.submitButtonLabel, containerStyle: {
                    marginTop: (0, scale_1.scale)(32),
                }, onPress: handleSubmit })),
        isLoading && react_1.default.createElement(LoadingLogin_1.default, null)));
};
exports.default = ChangePasswordScreen;
